import apiSlice from "./ApiSlice";

const FileApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // get all delivery dates
    getAllFileData: builder.query({
      providesTags: ["File"],
      query: (body: PaginationPayloadType) => {
        return {
          url: "/file-manager",
          method: "POST",
          body,
        };
      },
    }),

 
    // add delivery date
    addFile: builder.mutation({
      invalidatesTags: ["File"],
      query: (body) => ({
        url: `/file-manager/add-bulk-file`,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllFileDataQuery,
  useAddFileMutation,
} = FileApi;
